import configApi from './config';

const baseRoutesUrl = configApi.baseRoutesUrls.auth;

/**
 * Authentication routes constants
 * @module api/auth-routes
 */
export const AUTH_ROUTES = {
  SIGN_IN: `${baseRoutesUrl}/sign-in`,
  SIGN_UP: `${baseRoutesUrl}/sign-up`,
  SIGN_IN_SECOND_STEP: `${baseRoutesUrl}/second-step-login`,
  RECOVER_PASSWORD: `${baseRoutesUrl}/forgot-password`,
  CHANGE_PASSWORD: `${baseRoutesUrl}/forgot-password/confirmation`,
  REFRESH_TOKENS: `${baseRoutesUrl}/refresh-tokens`,
  LOGOUT: `${baseRoutesUrl}/log-out`,
};

/**
 * Array of all authentication routes for interceptor use
 */
export const authRoutes = Object.values(AUTH_ROUTES);

/**
 * Check if a URL is an authentication route
 * @param {string} url - URL to check
 * @returns {boolean}
 */
export function isAuthRoute(url) {
  return authRoutes.some((route) => url.includes(route));
}
